import { useEffect } from "react";
import "./Toast.css";

export interface ToastProps {
  message: string;
  duration?: number;
  type?: "success" | "error" | "info";
  onClose?: () => void;
}

export const Toast = ({
  message,
  duration = 2000,
  type = "success",
  onClose,
}: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`toast toast-${type}`} role="status">
      {type === "success" && <span className="toast-icon">✓</span>}
      {type === "error" && <span className="toast-icon">✕</span>}
      {type === "info" && <span className="toast-icon">ℹ</span>}
      <span className="toast-message">{message}</span>
    </div>
  );
};
